// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import Routers from './router/index'
import iView from 'iview'
import anchor from 'ant-design-vue/lib/anchor'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '../my-theme/dist/iview.css'

Vue.use(iView)
Vue.use(VueRouter)
Vue.use(anchor)
Vue.use(Antd)
Vue.config.productionTip = false
// The routing configuration
const RouterConfig = ({
  routes: Routers
})

const router = new VueRouter(RouterConfig)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js